import {injectable} from "inversify";
import store from '@/store';
import {PlayerMarker} from "@/store/player/types";
import Scene = Phaser.Scene;
import BattleLesson from "@/lesson.ui/battleLesson";
import Group = Phaser.GameObjects.Group;
import PlayerStore from "@/store/player";

@injectable()
export class BattleLessonService {

    private static readonly BATTLE_LESSON_MARKER: string = 'battleEducationCompleted';

    private battleLesson: BattleLesson | undefined;

    public showBattleLesson(scene: Scene, x: number, y: number, myCreatures: Group, enemyCreatures: Group) {
        if (!this.haveMarker(BattleLessonService.BATTLE_LESSON_MARKER)) {
            this.battleLesson = new BattleLesson(scene, x, y, myCreatures.getFirstAlive(),
                enemyCreatures.getLast(true));
            this.battleLesson.showLesson();
            scene.add.existing(this.battleLesson);
        }
    }

    private haveMarker(marker: String): Boolean {
        return PlayerStore.getPlayer()!.playerMarkers.some((m: PlayerMarker) => m.playerMarker == marker);
    }

    public setMarker() {
            if (!this.haveMarker(BattleLessonService.BATTLE_LESSON_MARKER)) {
                PlayerStore.setMarker(BattleLessonService.BATTLE_LESSON_MARKER);
                this.stopAndDeleteLesson();
            }
    }

    public stopAndDeleteLesson() {
        if (this.battleLesson) {
            this.battleLesson.destroyLesson();
            this.battleLesson = undefined;
        }
    }
}
